import { Typography } from '@styles';
import styled, { css, keyframes } from 'styled-components';

const cursorAnimation = keyframes`
  50% {
    border-color: transparent;
  }
`;

const typingAnimation = keyframes`
  from {
    width: 0;
  }
`;

export const Chars = styled(Typography)`
  ${({ dynamicWidth, isActive, isVisible, theme: { colors } }) =>
    isActive && isVisible
      ? css`
          width: ${dynamicWidth}px;
          border-right: 3px solid ${colors.white[100]};
          color: ${colors.white[100]};
          animation:
            ${typingAnimation} ${dynamicWidth / 100}s
              steps(
                ${parseInt(dynamicWidth / 3, 10) > 1
                  ? parseInt(dynamicWidth / 3, 10)
                  : 76}
              )
              forwards,
            ${cursorAnimation} 0.4s step-end ${dynamicWidth / 50}s alternate;
        `
      : css`
          width: fit-content;
          color: ${colors.white[100]};
          opacity: ${isVisible ? 1 : 0};
        `}

  overflow: hidden;
  position: relative;
`;

export const Container = styled.div`
  display: inline-block;
  width: 85%;
`;
